//证书管理-编辑
<template>
  <div class="CertificateManagement-add">
    <div class="list">
      <el-form
        ref="form"
        :model="form"
        label-width="120px"
        size="mini"
        :inline="false"
      >
        <div class="underline">
          <el-form-item label="名称：">
            <el-col :span="6">
              <el-input v-model="form.certName"></el-input>
            </el-col>
          </el-form-item>
        </div>
        <div class="underline">
          <el-form-item label="颁发单位：">
            <el-col :span="6">
              <el-input v-model="form.certUnit"></el-input>
            </el-col>
          </el-form-item>
        </div>
        <div class="underline">
          <div style="color: #000000">
            <el-form-item
              label="内容"
              prop="certContent"
              style="position: relative"
            >
              <quill-editor
                ref="quillEditor"
                v-model="form.certContent"
                :options="options"
                style="width: calc(100% - 40px)"
              >
                <div id="toolbar" slot="toolbar">
                  <button class="ql-bold" title="加粗">Bold</button>
                  <button class="ql-italic" title="斜体">Italic</button>
                  <button class="ql-underline" title="下划线">underline</button>
                  <button class="ql-strike" title="删除线">strike</button>
                  <button class="ql-blockquote" title="引用"></button>
                  <button class="ql-code-block" title="代码"></button>
                  <button
                    class="ql-list"
                    value="ordered"
                    title="有序列表"
                  ></button>
                  <button
                    class="ql-list"
                    value="bullet"
                    title="无序列表"
                  ></button>
                  <button class="ql-indent" value="+1" title="首行缩进">
                    indent
                  </button>
                  <select class="ql-header" title="段落格式">
                    <option selected>段落</option>
                    <option value="1">标题1</option>
                    <option value="2">标题2</option>
                    <option value="3">标题3</option>
                    <option value="4">标题4</option>
                    <option value="5">标题5</option>
                    <option value="6">标题6</option>
                  </select>
                  <select class="ql-size" title="字体大小">
                    <option value="10px">10px</option>
                    <option value="12px">12px</option>
                    <option value="14px">14px</option>
                    <option value="16px" selected>16px</option>
                    <option value="18px">18px</option>
                    <option value="20px">20px</option>
                  </select>
                  <select class="ql-font" title="字体">
                    <option value="SimSun" selected></option>
                    <option value="SimHei"></option>
                    <option value="Microsoft-YaHei"></option>
                    <option value="KaiTi"></option>
                    <option value="FangSong"></option>
                    <option value="Arial"></option>
                    <option value="Times-New-Roman"></option>
                    <option value="sans-serif"></option>
                  </select>
                  <select
                    class="ql-color"
                    value="color"
                    title="字体颜色"
                  ></select>
                  <select
                    class="ql-background"
                    value="background"
                    title="背景颜色"
                  ></select>
                  <select class="ql-align" value="align" title="对齐"></select>
                  <button class="ql-clean" title="还原"></button>
                </div>
              </quill-editor>
              <div style="color: gray">
                <span style="border: 1">元素路径：</span>
                <p>
                  你可以使用下面的变量代替相关信息:
                  [course_year]:加入课程年份　[course_month]:加入课程月份　[course_day]:加入课程日期(天)　[course_name]:课程名称　[grade]:取得的证书等级　[cert_unit]:证书颁发单位　[cert_name]:证书名称　[cert_code]:证书编号
                  [cert_start_time]:证书生效时间　[cert_end_time]:证书失效时间　[yyyy]:颁发年　[mm]:颁发月　[dd]:颁发日期(天)
                </p>
              </div>
            </el-form-item>
          </div>
        </div>
        <div class="underline">
          <el-form-item label="有效期：">
            <el-col :span="6">
              <el-input v-model="form.certValidityTime"></el-input>
            </el-col>
          </el-form-item>
          <div class="ann">
            <span>请填写数字,单位：天</span>
          </div>
        </div>
        <div class="underline">
          <el-form-item label="成绩等级评价：">
            <el-col :span="6">
              <el-input
                v-model="form.gradeList"
                @keyup.enter.native="searchEnterFun"
              ></el-input>
            </el-col>
          </el-form-item>
          <div class="ann">
            <span>格式：最小分数-最大分数#等级说明，编写完成后回车键添加</span>
          </div>
        </div>
      </el-form>
    </div>
    <div class="foot">
      <el-button type="primary" @click="saveOrUpdate">保存</el-button>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/CertificateManagement/api'
import { Quill, quillEditor } from 'vue-quill-editor' //调用编辑器
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/assets/css/quill.css'

// 自定义字体大小
const Size = Quill.import('attributors/style/size')
Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px']
Quill.register(Size, true)

// 自定义字体类型
const fonts = [
  'simSum',
  'SimHei',
  'Microsoft-YaHei',
  'KaiTi',
  'FangSong',
  'Arial',
  'Times-New-Roman',
  'sans-serif',
]
const Font = Quill.import('formats/font')
Font.whitelist = fonts
Quill.register(Font, true)

export default {
  components: {
    quillEditor,
  },
  props: ['formDataEdit'],
  data() {
    return {
      form: { ...this.formDataEdit },
      activeName: 'third',
      certType: '1',
      options: {
        placeholder: '',
        theme: 'snow',
        modules: {
          toolbar: '#toolbar',
        },
      },
    }
  },
  created() {
    console.log(this.form)
  },
  methods: {
    async saveOrUpdate() {
      const { code, msg } = (await api.saveOrUpdate(this.form)).data
      if (code === 100000) {
        this.$message({
          type: 'success',
          message: msg,
        })
        this.$emit('saveCertificate')
      } else {
        this.$message.error(msg)
      }
    },
  },
  //回车键
  searchEnterFun(e) {
    var keyCode = window.event ? e.keyCode : e.which
    console.log('回车', keyCode, e)
    if (keyCode == 13) {
      this.saveOrUpdate()
    }
  },
}
</script>
<style lang='scss' scoped>
.underline {
  border-bottom: dotted;
  color: #e4e4e4;
  border-bottom-width: 2px;
  margin-bottom: 20px;
}
/deep/ .quill-editor .ql-container {
  height: 200px;
}
.ann {
  padding-left: 110px;
  color: gray;
  font-size: 15px;
}
.foot {
  text-align: center;
}
</style>